import { Typography } from '@banhala/ui-kit';

export const MainName = ({ text }: { text: string }) => {
  return (
    <Typography type="subtitle1" ellipsizeMode="tail" color='content_primary'>
      {text}
    </Typography>
  );
};
